/**
 * FloorPlanCertification — registry entry (Component only; completeness is
 * registered separately in `modules/completeness.ts` per the A-01 split).
 */

import type { PfConfigModule } from '../registry'
import { FloorPlanCertification } from './FloorPlanCertification.component'

export const floorPlanCertificationModule: PfConfigModule = {
  flowId: 'floor_plan_certification',
  Component: FloorPlanCertification,
}
